export default __webpack_public_path__ + "static/media/toggle-monthly.75926d79.svg";